import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { URI } from "../../configs";

export const getSupportKnowledge = createAsyncThunk(
    "support/knowledge",
    async (token) => {
        const apiUrl = URI + "api/v1/support/knowledge/"
        var config = {
            method: "get",
            url: apiUrl,
            headers: {
                accept: "application/json",
                Authorization: `Token ${token}`
            },
        };
        const response = await axios(config);
        return response.data;
    }
);

export const askSupport = createAsyncThunk(
    "support/ask",
    async (arg) => {
        let token = arg.token
        let question = arg.question
        let history = arg.history || []
        const apiUrl = URI + "api/v1/support/ask/"
        var config = {
            method: "post",
            url: apiUrl,
            headers: {
                accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Token ${token}`
            },
            data: { question: question, history: history },
        };
        const response = await axios(config);
        return response.data;
    }
);
